import * as React from "react";
import type { SVGProps } from "react";
const SvgFolderOpen01 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M16.518 10.5h4.015c.59 0 1.067.478 1.067 1.067V18.1a2 2 0 0 1-2 2H4.8M2.4 4.967V18a2.1 2.1 0 0 0 4.2 0v-6.433c0-.59.478-1.067 1.067-1.067h11.8V7.978c0-.589-.478-1.066-1.067-1.066h-7.027l-1.63-2.524a1.07 1.07 0 0 0-.896-.488h-5.38c-.59 0-1.067.478-1.067 1.067"
    />
  </svg>
);
export default SvgFolderOpen01;
